var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"logo"},[_c('a',{on:{"click":function($event){$event.preventDefault();return (function () { _vm.$router.push('/').catch(function () {})})($event)}}},[_vm._v(" IAMCOST ")])])}
var staticRenderFns = []

export { render, staticRenderFns }